import { render, staticRenderFns } from "./StatusSetup.vue?vue&type=template&id=f120540c&scoped=true&"
import script from "./StatusSetup.vue?vue&type=script&lang=ts&"
export * from "./StatusSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120540c",
  null
  
)

export default component.exports